import { render } from "./IdentityForm.vue?vue&type=template&id=1d010cee&scoped=true&ts=true"
import script from "./IdentityForm.vue?vue&type=script&lang=ts"
export * from "./IdentityForm.vue?vue&type=script&lang=ts"

import "./IdentityForm.vue?vue&type=style&index=0&id=1d010cee&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d010cee"]])

export default __exports__